import { useTranslation } from 'react-i18next';

import { DataPanelAutoWrapInlineItem } from '@/ui';
import { openEditDispatcherNoteDialog } from '../actions';

export type DispatcherNotePanelProps = {
  incidentId: string;
  incidentIsReadOnly: boolean;
  note: string | null;
};

export function DispatcherNotePanel({ incidentId, incidentIsReadOnly, note }: DispatcherNotePanelProps) {
  const { t } = useTranslation();

  return (
    <DataPanelAutoWrapInlineItem
      title={t('Incident_InfoPanel_DispatcherNote')}
      value={note ?? undefined}
      editable={!incidentIsReadOnly}
      showEmptyPlaceholder
      onEditClick={() => openEditDispatcherNoteDialog(incidentId, note)}
    />
  );
}
